"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var Autocomplete_1 = __importDefault(require("atomicComponents/organisms/Autocomplete"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var InviteModal_1 = __importDefault(require("containers/Admin/CustomerManagement/InviteModal"));
var SimplifyFormInput_1 = __importDefault(require("shared/components/Form/HoC/SimplifyFormInput"));
var firestore_1 = require("utils/firebase/firestore");
var hooks_1 = require("utils/hooks");
var options_1 = require("utils/selectors/options");
var single_1 = require("utils/selectors/single");
var SimplifiedAutocomplete = (0, SimplifyFormInput_1.default)(Autocomplete_1.default);
var OwnerSelect = function (_a) {
    var serviceStat = _a.serviceStat;
    var _b = __read(react_1.default.useState(null), 2), inviteModalFor = _b[0], setInviteModalFor = _b[1];
    var _c = __read(react_1.default.useState(false), 2), isProcessingInvitation = _c[0], setIsProcessingInvitation = _c[1];
    var _d = __read(react_1.default.useState(false), 2), open = _d[0], setOpen = _d[1];
    var myCompany = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var allUserOptions = (0, react_redux_1.useSelector)(options_1.selectUserOptions);
    var _e = __read((0, hooks_1.useSubmitter)('service_stats', serviceStat.id), 2), submitter = _e[0], isSending = _e[1];
    var owner = serviceStat.owner, ownerId = serviceStat.ownerId;
    var selectedOwner = { value: ownerId || null, label: owner && (0, end2end_1.getDisplayName)(owner) };
    react_1.default.useEffect(function () {
        // When the assigneeToShowId changes after te invitation began processing, it means that the processing is done
        if (isProcessingInvitation) {
            setIsProcessingInvitation(false);
        }
    }, [ownerId]);
    var handleChange = function (valObj) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(valObj.value && valObj.value !== ownerId)) return [3 /*break*/, 2];
                    return [4 /*yield*/, submitter({ ownerId: valObj.value })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/, valObj];
            }
        });
    }); };
    if (!allUserOptions) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    if (isProcessingInvitation) {
        return (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ component: "span", ml: 1.5 }, { children: "Processing invitation" }));
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(SimplifiedAutocomplete, { isDisabled: isSending, label: "Add owner", options: allUserOptions, value: selectedOwner, placeholder: "Select an owner or create one", onChange: handleChange, onCreate: function (val) { setOpen(!open); setInviteModalFor(val.value); } }), (0, jsx_runtime_1.jsx)(InviteModal_1.default, { open: !!open, onClose: function () { return setOpen(false); }, targetDocRef: (0, firestore_1.makeDocRef)('service_stats', serviceStat.id), targetField: "ownerId", createUser: true, type: "billingOwner", defaultName: inviteModalFor || '', company: myCompany, onPostSubmit: function () { return setIsProcessingInvitation(true); } })] }));
};
exports.default = react_1.default.memo(OwnerSelect);
